import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { useState } from 'react';
import { SharedContactModel } from '../../../../types';
import GeneralDialog from '../../../shared/general-dialog';

import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

interface ContactEditOrganizationDialogProps {
  openOrganizationDialog: boolean;
  setOpenOrganizationDialog: (value: boolean) => void;
  clickedIndex: number;
  setValue: UseFormSetValue<Partial<SharedContactModel>>;
  disabled: boolean;
  getValues: UseFormGetValues<Partial<SharedContactModel>>;
}

export default function ContactEditOrganizationDialog({
  openOrganizationDialog,
  setOpenOrganizationDialog,
  clickedIndex,
  setValue,
  disabled,
  getValues,
}: ContactEditOrganizationDialogProps) {
  const [name, setName] = useState(() =>
    getValues(`orgs.${clickedIndex}.orgVal.orgName`)
  );
  const [title, setTitle] = useState(() =>
    getValues(`orgs.${clickedIndex}.orgVal.orgTitle`)
  );
  const [department, setDepartment] = useState(() =>
    getValues(`orgs.${clickedIndex}.orgVal.orgDepartment`)
  );
  const [location, setLocation] = useState(() =>
    getValues(`orgs.${clickedIndex}.orgVal.where`)
  );
  const [symbol, setSymbol] = useState(() =>
    getValues(`orgs.${clickedIndex}.orgVal.orgSymbol`)
  );
  const [description, setDescription] = useState(() =>
    getValues(`orgs.${clickedIndex}.orgVal.orgJobDescription`)
  );

  const formValuesHaveChanged =
    name !== getValues(`orgs.${clickedIndex}.orgVal.orgName`) ||
    title !== getValues(`orgs.${clickedIndex}.orgVal.orgTitle`) ||
    department !== getValues(`orgs.${clickedIndex}.orgVal.orgDepartment`) ||
    location !== getValues(`orgs.${clickedIndex}.orgVal.where`) ||
    symbol !== getValues(`orgs.${clickedIndex}.orgVal.orgSymbol`) ||
    description !== getValues(`orgs.${clickedIndex}.orgVal.orgJobDescription`);

  return (
    <GeneralDialog
      open={openOrganizationDialog}
      handleClose={() => {
        setOpenOrganizationDialog(false);
      }}
      title={'Edit Organization'}
      dialogContent={
        <Stack sx={{ px: 1 }} gap={4}>
          <Grid container spacing={4}>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                disabled={disabled}
                autoComplete="off"
                label="Organization Name"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                disabled={disabled}
                autoComplete="off"
                label="Employee Title"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={department}
                onChange={(e) => {
                  setDepartment(e.target.value);
                }}
                label="Employee Department"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={location}
                onChange={(e) => {
                  setLocation(e.target.value);
                }}
                label="Location"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={symbol}
                onChange={(e) => {
                  setSymbol(e.target.value);
                }}
                label="Stock Symbol"
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <TextField
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                label="Description"
                fullWidth
              />
            </Grid>
          </Grid>
        </Stack>
      }
      primaryButton={{
        loading: false,
        action: () => {
          if (formValuesHaveChanged) {
            setValue(`orgs.${clickedIndex}.orgVal.orgName`, name, {
              shouldDirty: true,
            });
            setValue(`orgs.${clickedIndex}.orgVal.orgTitle`, title, {
              shouldDirty: true,
            });
            setValue(`orgs.${clickedIndex}.orgVal.orgDepartment`, department, {
              shouldDirty: true,
            });
            setValue(`orgs.${clickedIndex}.orgVal.where`, location, {
              shouldDirty: true,
            });
            setValue(`orgs.${clickedIndex}.orgVal.orgSymbol`, symbol, {
              shouldDirty: true,
            });
            setValue(
              `orgs.${clickedIndex}.orgVal.orgJobDescription`,
              description,
              {
                shouldDirty: true,
              }
            );
          }

          setOpenOrganizationDialog(false);
        },
        disabled: !formValuesHaveChanged,
        title: 'Update',
      }}
    />
  );
}
